import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import {
  useTransition,
  useSpring,
  config,
  animated,
//  useTrail
} from "react-spring";
// qid is the node id from the drupal content type
// choices is the array of choices for the radio buttons
// onChoice is the function that will handle the radio opton
const Options = ({ items, onSelect, qid, selectedChoices }) => {
  const [hover, setHover] = useState(false);

  const hoverState = useSpring({
    transform: hover
      ? "translate3d(0px, -12px, 0px) scale(1.03)"
      : "translate3d(0px, 0px, 0px) scale(1)",
     boxShadow: hover
       ? '-1px 15px 45px 0px rgba(0, 0, 0, 0.3)'
       : '-1px 10px 45px 0px rgba(0, 0, 0, 0.2)',
    config: config.wobbly
  });

  //const trail = useTrail(items.length, {
  //  from: { opacity: 0, marginLeft: -20, marginRight: 100 },
  //  to: { opacity: 1, marginLeft: 0, marginRight: 0 }
  //});
  const transition = useTransition(items, item => item.choice_prompt, {
    from: { opacity: 0, marginLeft: -40, marginRight: 100 },
    enter: { opacity: 1, marginLeft: 0, marginRight: 0 }
  });

  return (
    <div className="checkBox">
      {transition.map(({ item, key, props }) => (
        <animated.div
          className="checkRow"
          key={key}
          style={props}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <label htmlFor={key}>
            <input
              type="checkbox"
              className="form-checkbox test"
              onChange={onSelect}
              value={item.choice_prompt}
              id={key}
              checked={selectedChoices.indexOf(item.choice_prompt) > -1}
            />
            {ReactHtmlParser(item.choice_prompt)}
          </label>
        </animated.div>
      ))}
      {/* {trail.map((animation, index) => (
        <animated.div
          style={animation}
          key={index}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <input
            type="checkbox"
            className="form-checkbox"
            onChange={onSelect}
            value={items[index].choice_prompt}
            checked={selectedChoices.indexOf(items[index].choice_prompt) > -1}
          />
          <label>{items[index].choice_prompt}</label>
        </animated.div>
      ))} */}
    </div>
  );
};

export default Options;
